import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";

interface IProps {
    askDisabled: boolean;
    isAsking: boolean;
    onAsk: () => void;
    onReject: () => void;
    rejectDisabled: boolean;
}

export function TinderMultiLeadBottomBar({askDisabled, isAsking, onAsk, onReject, rejectDisabled}: IProps) {
    return (
        <div className={bottomBarStyle}>
            <div className={bottomBarInnerStyle}>
                <Button
                    type="button"
                    variant="outlined_secondary"
                    onClick={onReject}
                    className={buttonStyle}
                    iconLeft={ThumbDownIcon}
                    disabled={rejectDisabled}
                >
                    Odrzuć
                </Button>
                <Button
                    type="button"
                    variant="filled_primary"
                    onClick={onAsk}
                    className={buttonStyle}
                    iconLeft={ThumbUpIcon}
                    disabled={askDisabled}
                    isLoading={isAsking}
                >
                    Zapytaj
                </Button>
            </div>
        </div>
    );
}

const bottomBarStyle = css({
    position: "sticky",
    bottom: 0,
    zIndex: 5,
    px: 2,
    py: 1.5,
    // Keep the buttons above the OS overlays (Android gesture nav / iOS home indicator).
    pb: "calc(1.2rem + env(safe-area-inset-bottom, 0px))",
    backgroundColor: "var(--colors-white)"
});

const bottomBarInnerStyle = css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 1.5,
    maxWidth: 560,
    mx: "auto"
});

const buttonStyle = css({
    minHeight: 48
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";

interface IProps {
    askDisabled: boolean;
    isAsking: boolean;
    onAsk: () => void;
    onReject: () => void;
    rejectDisabled: boolean;
}

export function TinderMultiLeadBottomBar({askDisabled, isAsking, onAsk, onReject, rejectDisabled}: IProps) {
    return (
        <div className={bottomBarStyle}>
            <div className={bottomBarInnerStyle}>
                <Button
                    type="button"
                    variant="outlined_secondary"
                    onClick={onReject}
                    className={buttonStyle}
                    iconLeft={ThumbDownIcon}
                    disabled={rejectDisabled}
                >
                    Odrzuć
                </Button>
                <Button
                    type="button"
                    variant="filled_primary"
                    onClick={onAsk}
                    className={buttonStyle}
                    iconLeft={ThumbUpIcon}
                    disabled={askDisabled}
                    isLoading={isAsking}
                >
                    Zapytaj
                </Button>
            </div>
        </div>
    );
}

const bottomBarStyle = css({
    position: "sticky",
    bottom: 0,
    zIndex: 5,
    px: 2,
    py: 1.5,
    // Keep the buttons above the OS overlays (Android gesture nav / iOS home indicator).
    pb: "calc(1.2rem + env(safe-area-inset-bottom, 0px))",
    backgroundColor: "var(--colors-white)"
});

const bottomBarInnerStyle = css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 1.5,
    maxWidth: 560,
    mx: "auto"
});

const buttonStyle = css({
    minHeight: 48
});
